import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleError, commonQueryOptions } from '../utils';
import { HiverCustomFieldNewAuth } from '../../../common';
import { CUSTOM_FIELD_API_ACTIONS, QUERY_KEYS } from '../constants';
import { QUERY_KEYS as CF_QUERY_KEYS } from '../../automationsV2/constants/customFields'

// API call to edit a custom field
const customFieldEditApi = (payload) => {
  const { cfId, ...rest } = payload;
  return HiverCustomFieldNewAuth({
    url: `/api/v1/config/edit/${cfId}`,
    method: 'PUT',
    data: rest,
  });
};

// Custom hook for the custom field edit API
export const useCustomFieldEditApi = (smId) => {
  const queryClient = useQueryClient(); // Using useQueryClient to access the query client

  return useMutation({
    ...commonQueryOptions,
    mutationKey: QUERY_KEYS.customFieldEdit,
    mutationFn: customFieldEditApi,
    onSuccess: () => {
      // Invalidate queries to ensure fresh data is fetched after mutation
      queryClient.invalidateQueries([QUERY_KEYS.customFieldList, smId]);
      queryClient.invalidateQueries([CF_QUERY_KEYS.GET_CUSTOM_FIELDS, smId]);
    },
    onError: (error, payload, context) => {
      // Rollback to the previous data if mutation fails
      if (context?.previousData) {
        queryClient.setQueryData([QUERY_KEYS.customFieldList, smId], context.previousData);
      }
      handleError(error); // Handle error
    },
    onMutate: (payload) => {
      if (payload.action === CUSTOM_FIELD_API_ACTIONS.EDIT) { // No optimistic update for EDIT action
        return;
      }
      // Optimistically update the cache before mutation
      const previousData = queryClient.getQueryData([QUERY_KEYS.customFieldList, smId]);
      queryClient.setQueryData([QUERY_KEYS.customFieldList, smId], (oldData = []) => {
        // Update the data with the new custom field values
        const updatedData = {
          ...oldData,
          data: {
            ...oldData.data,
            data: oldData.data.data.map((item) =>
              item.inbox_id == smId
                ? {
                    ...item,
                    custom_fields: item.custom_fields.map((cf) =>
                      cf.cf_id == payload.cfId ? { ...cf, ...payload } : cf
                    ),
                  }
                : item
            ),
          },
        };

        return updatedData;
      });
      return { previousData }; // Return the context for rollback in onError
    },
  });
};
